"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleHashOnHomepage = exports.initHashLinkScroll = void 0;
var nav_1 = require("../layout/nav");
var isHomepage = function () {
    var pathname = window.location.pathname;
    // Check if we're on the homepage (root path)
    return pathname === '/' || pathname === '';
};
var isAdminPage = function () {
    // Check if we're in WordPress admin area
    return window.location.pathname.indexOf('/wp-admin/') !== -1 ||
        document.body.classList.contains('wp-admin');
};
var initHashLinkScroll = function () {
    // Don't run in WordPress admin area to avoid interfering with plugins like Complianz
    if (isAdminPage()) {
        console.log('Admin page - not running hash link scroll');
        return;
    }
    var allHashLinks = document.querySelectorAll('a[href^="#"]');
    allHashLinks.forEach(function (link) {
        link.addEventListener('click', function (event) {
            var _a;
            event.preventDefault();
            var targetId = link.getAttribute('href');
            if (!targetId || targetId === '#' || targetId.includes('#open-track-record') || targetId.includes('#open-contact') || targetId.includes('#open-broadcast')) {
                return; // Invalid hash link
            }
            if (targetId.includes('#MenuPageScrollToTop')) {
                console.log('Menu page scrolling container');
                var nearestMenuPageScrollingContainer = link.closest('.menu-page-scrolling-container');
                if (nearestMenuPageScrollingContainer) {
                    nearestMenuPageScrollingContainer.scrollTo({ top: 0, behavior: 'smooth' });
                    return;
                }
                return;
            }
            if (targetId === '#ScrollDown') {
                // Find the nearest Parent that is a section tag
                var nearestSection = link.closest('section');
                if (nearestSection) {
                    var y = nearestSection.offsetHeight - 60;
                    window.scrollTo({ top: y, behavior: 'smooth' });
                }
                return;
            }
            // If we're on the homepage, scroll directly
            if (isHomepage()) {
                var targetElement = document.querySelector(targetId);
                var y = ((_a = targetElement === null || targetElement === void 0 ? void 0 : targetElement.offsetTop) !== null && _a !== void 0 ? _a : 0) - 60;
                if (y > 0) {
                    (0, nav_1.closeMenu)();
                    window.scrollTo({ top: y, behavior: 'smooth' });
                }
            }
            else {
                // Not on homepage - navigate to homepage with hash
                (0, nav_1.closeMenu)();
                window.location.href = "/".concat(targetId);
            }
        });
    });
};
exports.initHashLinkScroll = initHashLinkScroll;
// Handle hash scrolling when arriving at homepage with hash in URL
var handleHashOnHomepage = function () {
    // Don't run in WordPress admin area
    if (isAdminPage()) {
        console.log('Admin page - not running hash on homepage');
        return;
    }
    if (!isHomepage()) {
        return;
    }
    var hash = window.location.hash;
    if (!hash || hash === '#') {
        return;
    }
    // Small delay to ensure page is fully loaded
    // setTimeout(() => {
    var targetElement = document.querySelector(hash);
    if (targetElement) {
        var y = targetElement.offsetTop - 60;
        window.scrollTo({ top: y, behavior: 'smooth' });
    }
    // }, 100);
};
exports.handleHashOnHomepage = handleHashOnHomepage;
